/**
 * Widget 默认配置
 */

import { WidgetConfig } from './widget.types';

/**
 * 默认配置常量
 */
export const DEFAULT_CONFIG: WidgetConfig = {
  apiBaseUrl: '',
  themeColor: '#2563EB',
  title: '智能客服',
  subtitle: '在线 · 平均响应 < 2s',
  width: 380,
  height: 640,
  launcherPosition: 'middle-right',
  showLauncher: true,
  defaultOpen: false,
  debug: false,
  enableAnalytics: false,
};
